// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1l-kQ","rootNoMargin":"styles_rootNoMargin__1Zdow"};